import type { Quapp } from '../../../types/quapp'
import type { BridgeManager } from '../../../bridges'
import type { StoreUrls } from '../../../bridges/types'
import { QuappIframe } from './QuappIframe'
import { PushBridge } from './PushBridge'
import { BridgeUnavailableOverlay } from '../../../components/overlays'

interface MobileFrameProps {
  quapp: Quapp
  bridgeManager?: BridgeManager | null
  /** Whether to show the bridge unavailable overlay */
  showBridgeOverlay?: boolean
  /** The bridge feature that triggered the overlay */
  bridgeFeature?: string
  /** Store URLs for the bridge-unavailable overlay */
  storeUrls?: StoreUrls
  /** Called when overlay is closed */
  onCloseBridgeOverlay?: () => void
}

/**
 * The installed Quapp, rendered full-bleed (no store chrome).
 * Only mounted in standalone mode — the browser shows InstallLanding instead.
 */
export function MobileFrame({
  quapp,
  bridgeManager,
  showBridgeOverlay,
  bridgeFeature,
  storeUrls,
  onCloseBridgeOverlay,
}: MobileFrameProps) {
  return (
    <div className="fixed inset-0 bg-white overflow-hidden">
      <QuappIframe quapp={quapp} bridgeManager={bridgeManager} />
      {/* closed-app reminders — the shell owns the push scope; Quapps request it over postMessage */}
      <PushBridge quapp={quapp} />

      {showBridgeOverlay && bridgeFeature && onCloseBridgeOverlay && (
        <BridgeUnavailableOverlay
          feature={bridgeFeature}
          storeUrls={storeUrls || { android: null, ios: null }}
          onClose={onCloseBridgeOverlay}
        />
      )}
    </div>
  )
}
